import {useMemo} from 'react';

import {useConsent, usePendo} from '@newsela/snitch';
import {connect} from 'react-redux';

import {DATAGRAIL_PERFORMANCE_CATEGORY} from 'static/three-oh/src/datagrailIntegration/config';
import {getUserAttributes} from 'static/three-oh/src/modules/selectors/userAttributesSelectors';
import {getUser, getUserProperties} from 'static/three-oh/src/modules/selectors/userSelectors';

import mapUserToPendoProperties from './mapUserToPendoProperties';

const PendoTrackingContainer = ({user, userAttributes, isImpersonated}) => {
  const pendoUser = useMemo(
    () => mapUserToPendoProperties(user, userAttributes, {isImpersonated: !!isImpersonated}),
    [user, userAttributes, isImpersonated]
  );
  const hasConsent = useConsent(DATAGRAIL_PERFORMANCE_CATEGORY);

  usePendo({
    user: pendoUser,
    enabled: Boolean(pendoUser) && Boolean(userAttributes) && Boolean(window.PENDO_ENABLED),
    isConsentGranted: hasConsent,
    product: 'monolith',
  });

  return null;
};

const mapStateToProps = (state) => {
  return {
    user: getUser(state),
    userAttributes: getUserAttributes(state),
    isImpersonated: getUserProperties(state).isImpersonated,
  };
};

export default connect(mapStateToProps)(PendoTrackingContainer);
